import React, { useState, useEffect, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import lozad from "lozad";
import {
  SEARCH_ICON,
  ICON_PLUS,
  COPIED_ICON,
  GOLDEN_KEY,
  NEW_GB,
} from "src/constants/images";
import { FiExternalLink } from "react-icons/fi";
import * as icon from "../../services/icon";
import { PROFILE } from "src/constants/routes";
import WalletSkeleton from "components/Loader/Skeleton/WalletSkeleton";
import { replaceFloatValue } from "utils/replaceFloatValue";
import WalletImageSkeleton from "components/Loader/Skeleton/WalletImageSkeleton";
import axios from "axios";
const GangstaCard = lazy(() => import("../GangstaCard/GangstaCard"));
const IllustrationCard = lazy(() => import("../IllustrationCard/IllustrationCard"))

const WalletCustomerDetail = ({
  totalOwned,
  gangstaCollection,
  address,
  lazyLoadingGansta,
  accumulatedGbet,
  gbetInWallet,
  id,
  isLoading,
  setMultiClaimModal,
  userGGReward,
  setGGRewardDisplayShow,
  lastClaimTimer,
  ownerAccount,
  bOMMreward500kPool,
  goldenKeyCount,
}) => {
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(false);

  let [viewAbleGangstaCollection, setViewAbleGangstaCollection] =
    useState(gangstaCollection);
  const [searchKeyWord, setSearchKeyWord] = useState("");

  const [isSearchActive, setSearchActiveState] = useState(false);
  const [isSortingState, setSortingState] = useState({
    currentState: "",
    type: {
      DESC: "Stat: High - Low",
      ASC: "Stat: Low - High",
    },
  });
  const handleRedirection = (hex) => {
    const route = PROFILE.addSlug(PROFILE.INDEX, parseInt(hex));

    navigate(route);
  };

  const [toggleComponent, setToggleComponent] = useState({ name: "gangstaBet" });
  const [userOwnedIllustrations, setUserOwnedIllustrations] = useState([]);

  useEffect(() => {
    async function runEffect() {
      const illustratioReservation = await icon.getReservations(id);
      const userOwnedIllustrationsArray = [...userOwnedIllustrations];

      for await (let illustration of illustratioReservation) {
        if (illustration.minted === "0x1") {
          const token = await icon.getIllustrationTokenURI(illustration.id)
          if (token) {
            const { data } = await axios.get(token + ".json");
            userOwnedIllustrationsArray.push({ name: data.name, image_url: data.image_url, gangstabet_id: data.gangstabet_id, id: data.id })
          }
        }
      }
      setUserOwnedIllustrations([...userOwnedIllustrationsArray]);
    }
    runEffect();
  }, []);

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    setViewAbleGangstaCollection(gangstaCollection);
  }, [gangstaCollection]);

  useEffect(() => {
    setViewAbleGangstaCollection([]);
    setViewAbleGangstaCollection(gangstaCollection);
  }, [gangstaCollection]);

  useEffect(() => {
    const observer = lozad();

    observer.observe();
  }, []);

  const handleNameSearch = () => {
    setViewAbleGangstaCollection([]);
    if (searchKeyWord.length >= 1) {
      let matchedNFTs = [];
      gangstaCollection.map((nft, index) => {
        if (
          nft._nftData.token_name
            .toLowerCase()
            .includes(searchKeyWord.toLowerCase())
        ) {
          matchedNFTs.push(nft);
        }
      });
      setViewAbleGangstaCollection(matchedNFTs);
      setSearchActiveState(true);
    } else {
      resetSearch();
    }
  };

  const handleSorting = (type) => {
    setViewAbleGangstaCollection([]);
    let data = [];
    if (type == "ASC") {
      data = viewAbleGangstaCollection;
      data.sort((x, y) => {
        return x._nftData.total_stats - y._nftData.total_stats;
      });
      setSortingState((prev) => {
        return {
          ...prev,
          currentState: "ASC",
        };
      });
    } else if (type == "DESC") {
      data = viewAbleGangstaCollection;
      data.sort((x, y) => {
        return y._nftData.total_stats - x._nftData.total_stats;
      });
      setSortingState((prev) => {
        return {
          ...prev,
          currentState: "DESC",
        };
      });
    } else {
      data = gangstaCollection;
    }

    setViewAbleGangstaCollection(data);
  };

  const resetSearch = () => {
    setViewAbleGangstaCollection([]);
    setViewAbleGangstaCollection(gangstaCollection);
    setSearchActiveState(false);
    setSearchKeyWord("");
  };

  const handleCopied = (address) => {
    // setIsCopied(!isCopied);
    navigator.clipboard.writeText(address);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 3000);
  };

  return (
    <>
      {loading || isLoading ? (
        <WalletSkeleton />
      ) : (
        <>
          <div className="wallet-information p-3">
            <div className="wallet-information__header">
              <div className="absolute-alert-wp">
                {alert && (
                  <div
                    class="alert-primary alert-dismissible alert-wp fade show px-3"
                    role="alert"
                  >
                    User address copied!
                  </div>
                )}
              </div>

              <div className="user-info">
                <div className="user-address-wp owner-key">
                  <svg
                    className={`${"iconex-icon"}`}
                    width="14"
                    height="14"
                    viewBox="0 0 120 120"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    stroke-linejoin="round"
                    stroke-miterlimit="2"
                  >
                    <g transform="translate(-135)" fill="#2ca9b7">
                      <path
                        d="M233.5 31.4l-13 13c2.8 4.6 4.4 9.9 4.4 15.7 0 16.6-13.4 30-30 30-5.7 0-11.1-1.6-15.7-4.4l-13 13c8 5.9 17.9 9.5 28.6 9.5 26.5 0 48-21.5 48-48 .2-10.9-3.3-20.8-9.3-28.8zM165 60c0-16.6 13.4-30 30-30 5.7 0 11.1 1.6 15.7 4.4l13-13c-8-5.9-17.9-9.5-28.6-9.5-26.5 0-48 21.5-48 48 0 10.7 3.5 20.6 9.5 28.6l13-13c-3-4.4-4.6-9.8-4.6-15.5z"
                        fill-rule="nonzero"
                      />
                      <circle cx="243" cy="12" r="12" />
                      <circle cx="147" cy="108" r="12" />
                    </g>
                  </svg>
                  <span className="address-top-wp">
                    {address !== id
                      ? id.slice(0, 12) + "..." + id.slice(-4)
                      : address.slice(0, 12) + "..." + address.slice(-4)}
                  </span>

                  <img
                    src={COPIED_ICON.SOURCE}
                    alt="copied-item"
                    width={13}
                    className="copy-icon-wp"
                    onClick={() => handleCopied(id)}
                  />
                </div>

                <div className="user-content-wrap-wp">
                  <div className="accumulated-gbet-wp d-flex flex-row flex-content-wp">
                    <div className="d-flex">
                      <div className="wp-icon">
                        <div className="round-bg-wp">
                          <img src={NEW_GB.SOURCE} className="new-gb" />
                        </div>
                      </div>
                      <div className="wp-vals">
                        {/* <br /> */}
                        <p className="val-heading-wp">ACCUMULATED</p>
                        <p className="val-count-wp">
                          <span className="val-amt">
                            {accumulatedGbet.toLocaleString("en-US")}
                          </span>
                          <span className="val-tail">$GBET</span>
                        </p>
                        {accumulatedGbet > 0 && address == id ? (
                          <span
                            className="val-link-wp"
                            onClick={() => {
                              setMultiClaimModal(true);
                            }}
                          >
                            Claim All
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  {/* <br /> */}

                  <div className="wallet-gbet-wp d-flex flex-row flex-content-wp">
                    <div className="d-flex">
                      <div className="wp-icon">
                        <div className="round-bg-wp">
                          <img src={NEW_GB.SOURCE} className="new-gb" />
                        </div>
                      </div>
                      <div className="wp-vals">
                        {/* <br /> */}
                        <p className="val-heading-wp">WALLET</p>
                        <p className="val-count-wp">
                          <span className="val-amt">
                            {parseFloat(
                              replaceFloatValue(gbetInWallet)
                            ).toLocaleString("en-US")}{" "}
                          </span>
                          <span className="val-tail">$GBET</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* <hr /> */}

                  {/* <div className="accumulated-crown-wp d-flex flex-row flex-content-wp">
                    <div className="d-flex">
                      <div className="wp-icon">
                        <div className="round-bg-wp">
                          <img src={CROWN.SOURCE} />
                        </div>
                      </div>
                      <div className="wp-vals">
                        <p className="val-heading-wp">ACCUMULATED</p>
                        <p className="val-count-wp">
                          <span className="val-amt">
                            {userGGReward
                              ? (
                                  userGGReward?.rewards?.total_gg_reward +
                                  bOMMreward500kPool
                                )
                                  .toFixed(2)
                                  .toLocaleString("en-US")
                              : "0.00"}
                          </span>
                          <span className="val-tail">$CROWN</span>
                        </p>

                        {userGGReward?.rewards.total_gg_reward >= 0 &&
                        address == id ? (
                          <span
                            className="val-link-wp"
                            onClick={() => {
                              setGGRewardDisplayShow(true);
                            }}
                          >
                            Show Details
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div> */}

                  <div className="wallet-key-wp d-flex flex-row flex-content-wp">
                    <div className="d-flex">
                      <div className="wp-icon">
                        <div className="round-bg-wp">
                          <img src={GOLDEN_KEY.SOURCE} />
                        </div>
                      </div>
                      <div className="wp-vals">
                        <p className="val-heading-wp">WALLET</p>
                        <p className="val-count-wp">
                          {goldenKeyCount >= 1 ? (
                            <>
                              {" "}
                              <span className="val-amt">
                                {goldenKeyCount}
                              </span>{" "}
                              <span className="val-tail">
                                GOLDEN KEYS{" "}
                                {/* <span className="custom-tooltip">
                                  <span className="tooltiptext">
                                    View in Craft marketplace
                                  </span>
                                  
                                </span> */}
                                <a
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                  href="https://craft.network/nft/cx5f1cc357f2304fb2646e20211adbe137ab5852dd:1"
                                  target="_blank"
                                >
                                  <FiExternalLink
                                    style={{ fontSize: "15px" }}
                                  />
                                </a>
                              </span>{" "}
                            </>
                          ) : (
                            <>
                              <span className="val-amt">0</span>{" "}
                              <span className="val-tail">
                                GOLDEN KEY{" "}
                                <a
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                  href="https://craft.network/nft/cx5f1cc357f2304fb2646e20211adbe137ab5852dd:1"
                                  target="_blank"
                                >
                                  <FiExternalLink
                                    style={{ fontSize: "15px" }}
                                  />
                                </a>
                              </span>
                            </>
                          )}
                        </p>
                        {/* <span className="custom-nav-tooltip tooltip-wp"> */}
                        {/* <span className="tooltiptext"> Info about golden key </span> */}
                        <span className="val-link-wp learn-more">
                          <a
                            href="https://docs.gangstabet.io/gangstaverse/the-emerald-city/golden-keys"
                            target="_blank"
                            style={{ fontSize: "14px !important" }}
                          >
                            {" "}
                            What's a Golden Key?
                          </a>
                        </span>
                        {/* </span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="gangstabet-listings container">
              <div className="container" style={{ "width": "95%" }}>
                <div className="gb-listing-body">
                  <header className="d-flex">
                    <div
                      className={`nav-item ${toggleComponent.name == "gangstaBet" ? "active" : ""}`}
                      onClick={() => {
                        setToggleComponent({ name: "gangstaBet" });
                      }}
                    >
                      GangstaBet ({parseInt(totalOwned)})
                    </div>
                    {userOwnedIllustrations.length > 0 ? <div
                      className={`nav-item ${toggleComponent.name == "illustration" ? "active" : ""}`}
                      onClick={() => {
                        setToggleComponent({ name: "illustration" });
                      }}
                    >
                      Illustration ({userOwnedIllustrations.length})
                    </div> : null}

                  </header>
                </div>
              </div>
            </div>

            {toggleComponent.name == "gangstaBet" ? <> <div className="gangstar-list d-flex flex-column mt-lg-0">
              <div className="d-flex ms-3 mb-2">
              </div>
              <div className="wallet-search-sort-section ms-3 mb-2">
                <div className="search-box">
                  <input
                    type="text"
                    autocomplete="off"
                    className={`form-control w-100  search-input`}
                    id="price"
                    aria-describedby="price"
                    disabled={lazyLoadingGansta}
                    placeholder="Search"
                    value={searchKeyWord}
                    style={{
                      paddingRight: `${isSearchActive ? "3.5em" : "2em"}`,
                    }}
                    required
                    onKeyDown={(evt) => {
                      if (evt.key === "Enter") {
                        handleNameSearch();
                      }
                    }}
                    onChange={(e) => setSearchKeyWord(e.target.value)}
                  />
                  <img
                    src={ICON_PLUS.SOURCE}
                    alt="search"
                    onClick={() => {
                      setViewAbleGangstaCollection([]);
                      resetSearch();
                      setViewAbleGangstaCollection(gangstaCollection);
                      setSearchActiveState(false);
                      setSearchKeyWord("");
                    }}
                    className={`plus-icon position-absolute ${
                      isSearchActive ? "active" : ""
                    }`}
                  />
                  <img
                    src={SEARCH_ICON.SOURCE}
                    alt="search"
                    onClick={() => {
                      if (!lazyLoadingGansta) {
                        handleNameSearch();
                      }
                    }}
                    className="search-icon position-absolute translate-middle-y"
                  />
                </div>

                <div className="sort-section">
                  <div className="sort">
                    <div className="alley-topGangster">
                      <div className="tg-top">
                        <div
                          className="filter-container"
                          // style={{ border: "1px solid var(--market-filter)" }}
                        >
                          {/* <div
                          className="filter-text"
                          style={{ backgroundColor: "var(--market-filter)" }}
                        >
                          Sort
                        </div> */}
                          <div
                            className="al-filters dropdown-toggle"
                            id="dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <div className="al-filter-selected ">
                              {isSortingState.type[isSortingState.currentState]
                                ? isSortingState.type[
                                    isSortingState.currentState
                                  ]
                                : "Sort by:  "}
                            </div>{" "}
                            &nbsp;&nbsp;
                            {
                              <svg
                                width="18px"
                                height="18px"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17.92 8.17969H11.69H6.07999C5.11999 8.17969 4.63999 9.33969 5.31999 10.0197L10.5 15.1997C11.33 16.0297 12.68 16.0297 13.51 15.1997L15.48 13.2297L18.69 10.0197C19.36 9.33969 18.88 8.17969 17.92 8.17969Z"
                                  fill="#DADADA"
                                />
                              </svg>
                            }
                          </div>
                          <ul
                            class="dropdown-menu p-3"
                            aria-labelledby="sortby"
                          >
                            {Object.entries(isSortingState.type).map(
                              ([key, value], index) => (
                                <li key={index} className="mb-1">
                                  <button
                                    class="dropdown-item"
                                    onClick={() => handleSorting(key)}
                                  >
                                    {value}
                                  </button>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={viewAbleGangstaCollection.length !== 0 ? "p-3" : ""}>
                {viewAbleGangstaCollection.length != 0 ? (
                  <>
                    <div className="wallet-card-container d-flex justify-content-center justify-content-sm-start flex-wrap">
                      {viewAbleGangstaCollection.map((nft, index) => (
                        <Suspense
                          fallback={
                            <div className="image-block position-relative w-100 h-100">
                              <div
                                class="spinner-border position-absolute spinner"
                                role="status"
                              >
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          }
                        >
                          {console.log("name", nft)}
                          <GangstaCard
                            name={nft._nftData.token_name}
                            // image={nft.token_uri}
                            image={nft.token_uri}
                            key={index}
                            stats={nft._nftData.total_stats}
                            number={nft._nftData.id}
                            ownerAccount={ownerAccount}
                            isGangster={nft._nftData.isGangster}
                            type={nft.type}
                            fromWallet={true}
                            lastClaimTimer={lastClaimTimer}
                            class_type={nft._nftData.class_type}
                            data={nft._nftData.skills}
                            id={nft.id}
                            for_sale={
                              nft._nftData.salePrice == -1 ? false : true
                            }
                            selling_price={nft._nftData.salePrice}
                            accumulatedGBET={nft._nftData.accumulatedGbet}
                            isAccumulatedGBETLoading={false}
                          />
                        </Suspense>
                      ))}
                    </div>
                  </>
                ) : !isLoading &&
                  !loading &&
                  viewAbleGangstaCollection.length < 1 ? (
                  !lazyLoadingGansta ? (
                    <div className="no-card mt-3">
                      <p className="desc">
                        It seems that you don't have any GangstaBet Collection
                        yet.
                      </p>
                    </div>
                  ) : (
                    <WalletImageSkeleton />
                  )
                ) : viewAbleGangstaCollection.length == 0 ? (
                  <WalletImageSkeleton />
                ) : (
                  ""
                )}
              </div>
            </div></> :
              <div className="d-flex flex-row flex-wrap" style={{ padding: "0px 24px", gap: "1.4em" }}>

                {userOwnedIllustrations.length == 0 ? <div className="no-card mt-3">
                  <p className="desc">
                    It seems that you don't have any Illustration Collection
                    yet.
                  </p>
                </div> : <>
                  {userOwnedIllustrations.map((nft, index) => (
                    <Suspense
                      fallback={
                        <div className="image-block position-relative w-100 h-100">
                          {/* <div
                            class="spinner-border position-absolute spinner"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </div> */}
                        </div>
                      }
                    >
                      <a href={`https://craft.network/nft/gangstabet-illustration:` + nft.id} target="_blank">
                        <IllustrationCard
                          name={nft.name}
                          image={nft.image_url}
                          key={index}
                          gangstabet_id={`GangstaBet #${nft.gangstabet_id}`}
                          id={nft.id}
                        />
                      </a>
                    </Suspense>
                  ))}</>}
              </div>
            }
          </div>
        </>
      )}
    </>
  );
};

export default WalletCustomerDetail;
